import axios from "axios";

const AUTH_HEADER = () => {
   return {
      headers: {
         Authorization: "Bearer " + process.env.REACT_APP_API_TOKEN,
         "Content-Type": "application/json",
         "Access-Control-Allow-Origin": "*",
      },
   };
};

const AUTH_HEADER_FILE = () => {
   return {
      headers: {
         Authorization: "Bearer " + process.env.REACT_APP_API_TOKEN,
         "Content-Type": "multipart/form-data",
         "Access-Control-Allow-Origin": "*",
      },
   };
};

export const SalvarLogErro = (origemErro, err) => {
   let erro = null;

   if (err?.response?.data?.error) {
      erro = err?.response?.data?.error;
   }
   else {
      erro = err?.message;
   }

   //SalvarLogSentry

   console.error(`Ocorreu um erro ${origemErro}: `, err);

   //alert(erro);

   return null;
}

const logout = () => {

}

export const POST_AUTH = async (obj = {}) => {
   try {
      const endpoint = process.env.REACT_APP_API_DESIGN.replace(
         "/api",
         "/authentication"
      );
      const response = await axios.post(endpoint, obj);
      if (response.status >= 200 && response.status <= 299)
         return response?.data;

      return null;
   } catch (err) {
      return SalvarLogErro('/authentication', err);
   }
};

export const POST_DATA = async (endpoint, obj = {}) => {
   try {
      const response = await axios.post(
         `${process.env.REACT_APP_API}/${endpoint}`,
         obj,
         AUTH_HEADER()
      );
      if (response.status >= 200 && response.status <= 299)
         return response?.data;
      return null;
   } catch (err) {
      if (err?.response?.status === 401) {
         //Não autorizado
         logout();

         alert("Sessão expirada!\n Favor realizar o login novamente");
         window.location.href = "/login";
      }
      return SalvarLogErro(endpoint, err);
   }
};

export const DELETE_DATA = async (endpoint) => {
   try {
      const response = await axios.delete(
         `${process.env.REACT_APP_API}/${endpoint}`,
         AUTH_HEADER()
      );
      if (response.status >= 200 && response.status <= 299)
         return response?.data;
      return null;
   } catch (err) {
      if (err?.response?.status === 401) {
         //Não autorizado
         logout();

         alert("Sessão expirada!\n Favor realizar o login novamente");
         window.location.href = "/login";
      }

      return SalvarLogErro(endpoint, err);
   }
};

export const PUT_DATA = async (endpoint, obj = {}) => {
   try {
      if (endpoint === 'Imagem/GetListImagemFilterPaginationCRM') {
         const response = await axios.put(`${process.env.REACT_APP_API}/${endpoint}`, obj, AUTH_HEADER());
         if (response.status >= 200 && response.status <= 299) return response?.data;
         return null;
      }
   }
   catch (err) {
      if (err?.response?.status === 401) {
         //Não autorizado
         logout();

         alert("Sessão expirada!\n Favor realizar o login novamente");
         window.location.href = "/login";
      }

      return SalvarLogErro(endpoint, err);
   }
};

export const GET_DATA = async (endpoint, showValidation = false) => {
   try {
      const response = await axios.get(
         `${process.env.REACT_APP_API}/${endpoint}`,
         AUTH_HEADER()
      );
      if (response.status >= 200 && response.status <= 299)
         return response?.data;
      return null;
   } catch (err) {
      if (showValidation && err?.response?.status === 401) {
         //Não autorizado
         logout();

         alert("Sessão expirada!\n Favor realizar o login novamente");
         window.location.href = "/login";
      }

      return SalvarLogErro(endpoint, err);
   }
};